import {Injectable, signal} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  linksEnabled = signal(true);
}
